import React from "react";

export const LumenExpandIcon = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    width="15"
    height="15"
    viewBox="0 0 138 167.5"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={2}
    className={className}
  >
    <path fill="currentColor" d="M17.781,110.343l0,-28.443c0,-2.875 -2.334,-5.208 -5.208,-5.208c-2.875,-0 -5.208,2.333 -5.208,5.208l-0,41.017c-0,0.819 0.189,1.595 0.527,2.285l0.042,0.086l0.007,0.013c0.205,0.397 0.463,0.773 0.776,1.116l0.089,0.097c0.028,0.028 0.056,0.057 0.084,0.086c0,-0 0.048,0.047 0.048,0.047l0.043,0.041l0.091,0.085c0.344,0.313 0.72,0.571 1.116,0.775l0.099,0.05c0.691,0.338 1.466,0.527 2.286,0.527l41.017,0c2.874,-0 5.208,-2.334 5.208,-5.208c-0,-2.875 -2.334,-5.209 -5.208,-5.209l-28.443,0l36.534,-36.533c2.032,-2.033 2.032,-5.334 -0,-7.366c-2.033,-2.033 -5.333,-2.033 -7.366,-0l-36.534,36.534Zm94.572,-94.718l-36.534,36.534c-2.032,2.032 -2.032,5.333 0,7.366c2.033,2.032 5.333,2.032 7.366,-0l36.534,-36.534l-0,28.442c-0,2.875 2.334,5.209 5.208,5.209c2.875,-0 5.208,-2.334 5.208,-5.209l0,-41.016c0,-0.82 -0.189,-1.596 -0.527,-2.286l-0.042,-0.085l-0.007,-0.014c-0.205,-0.397 -0.463,-0.772 -0.776,-1.116l-0.089,-0.096c-0.028,-0.029 -0.056,-0.058 -0.084,-0.086c-0,-0 -0.048,-0.047 -0.048,-0.047l-0.043,-0.042l-0.091,-0.085c-0.344,-0.312 -0.72,-0.571 -1.116,-0.775l-0.099,-0.049c-0.691,-0.338 -1.466,-0.528 -2.286,-0.528l-41.017,0c-2.874,0 -5.208,2.334 -5.208,5.209c0,2.874 2.334,5.208 5.208,5.208l28.443,0Z" />
  </svg>
);

export const LumenCollapseIconSmall = ({ className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    {...props}
  >
    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const LumenMinimizeIconSmall = () => (
  <svg width="15" height="30" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 30" enableBackground="new 0 0 24 24" x="0px" y="0px"><g>
      <path fill="currentColor" d="M14 11c-.129 0-.259-.025-.383-.076-.374-.155-.617-.52-.617-.924v-7c0-.552.447-1 1-1s1 .448 1 1v4.586l7.293-7.293c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-9 9c-.191.191-.447.293-.707.293zM21 11h-7c-.553 0-1-.448-1-1s.447-1 1-1h7c.553 0 1 .448 1 1s-.447 1-1 1zM1 24c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414l9-9c.286-.286.715-.374 1.09-.217.373.154.617.52.617.924v7c0 .553-.448 1-1 1s-1-.447-1-1v-4.586l-7.293 7.293c-.195.195-.451.293-.707.293zM10 15h-7c-.552 0-1-.447-1-1s.448-1 1-1h7c.552 0 1 .447 1 1s-.448 1-1 1z" />
    </g></svg>
)

export default { LumenExpandIcon, LumenMinimizeIconSmall,LumenCollapseIconSmall };